import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { UploadService } from '../../../../../../../../common/services/Upload.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { IvrService } from '../../../../../../../../common/services/Ivr.service';
import { IvrConst } from '../../ivr.const';
import { TableAction } from '../../../../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../../../../components/base-list.component';
import {
  FormFieldType,
  ModalType,
} from '../../../../../../../../components/modals/modal-form-template/modal-form.const';
import * as _ from 'lodash';
import { isPhoneNumber } from '../../../../../../../../common/utils/validate';

@Component({
  selector: 'switchboard-ivr-script-list',
  templateUrl: './list.component.html',
  styleUrls: ['../../ivr.component.css', '../../../switchboard.component.css'],
})
export class ListComponent extends BaseListComponent {
  @ViewChild('ivrTemplate') ivrTemplate: ElementRef;
  @Output() onOpenView = new EventEmitter();
  public displayColumns: any = [];
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public change_message: any = [];
  public model: any = {};
  public modelFilter: any = {};
  public typeModal = 'add';
  public modalRef: any = {};
  public modalRef2: any = {};
  public totalItem: any = 0;
  public totalPage: any = 0;
  public is_load_data: any = false;

  public user: any;

  public id_delete: number;

  public lstChecked: any = [];
  public isCheckAll = false;
  public audio_path = '';

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private uploadService: UploadService,
    private ivrService: IvrService
  ) {
    super(changeDetector, toastr, modalService);
    this.user = JSON.parse(localStorage.getItem('User'));
    this.displayColumns = IvrConst.displayIvrColumns();
  }

  ngOnInit() {
    this.loadData().then();
  }

  async loadData(request: any = {}, sort: any = {}) {
    const payloads = await this.buildBasePayload(request, sort);
    this.ivrService.listCP(payloads).subscribe(
      res => {
        if (!res.error && res.status == 200) {
          this.data = res.data.ivr_cp;
          this.initPage(res.data.total);
        } else {
          this.throwError();
        }
      },
      err => {
        this.throwError(err.message);
      }
    );
  }

  async addCp() {
    if (!isPhoneNumber(this.model.RULE)) {
      return (this.message = {
        class: 'alert dark alert-danger',
        content: 'Đầu số không đúng định dạng!',
      });
    }
    if (this.model.NAME) {
      this.model.NAME = this.model.NAME.trim();
    }
    if (this.model.RULE) {
      this.model.RULE = this.model.RULE.trim();
    }
    this.ivrService.createCP(this.model).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Thêm mới không thành công',
            };
            this.toastr.error('Thêm mới thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Thêm mới thành công',
            };
            this.toastr.success('Thêm mới thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });

            this.loadData();
            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
    // }
  }

  async editCp() {
    this.message = null;
    const payload = {};
    if (this.model.NAME) {
      payload['NAME'] = this.model.NAME.trim();
    }
    if (this.model.RULE) {
      payload['RULE'] = this.model.RULE.trim();
    }

    this.ivrService.updateCP(this.model.CP_ID, payload).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Cập nhật không thành công',
            };
            this.toastr.error('Cập nhật thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Cập nhật thành công',
            };
            this.toastr.success('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
    // }
  }

  async submitDelete() {
    this.ivrService.deleteCP(this.id_delete).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.toastr.error('Xóa không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }
  async openConfirmDelete(id) {
    this.id_delete = id;
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDelete();
    }
  }

  async setUpModel() {
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới kịch bản IVR' : 'Cập nhật kịch bản IVR',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'NAME',
        label: 'Tên kịch bản',
        type: FormFieldType.Text,
        value: this.model.NAME,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'RULE',
        label: 'Đầu số',
        type: FormFieldType.Text,
        value: this.model.RULE,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
      },
    ];
  }
  async handleAction(type: any, item?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-md',
    };
    this.model = {};
    switch (type) {
      case TableAction.add:
        this.typeModal = 'add';
        await this.setUpModel();
        await this.openModal(this.ivrTemplate, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.view:
        await this.onOpenView.emit({ item: item });
        break;
      case TableAction.edit:
        this.model = item;
        this.typeModal = 'edit';
        await this.setUpModel();
        await this.openModal(this.ivrTemplate, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.delete:
        await this.openConfirmDelete(item.CP_ID);
        break;
    }
  }
  async onChangeValueModel(key, item?: any) {
    this.model = _.merge({}, this.model, item);
    this.message = null;
    switch (key) {
      case 'RULE':
        if (!isPhoneNumber(this.model.RULE) && item[key]) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Đầu số không đúng định dạng!',
          };
        }
        break;
      default:
        break;
    }
    await this.setUpModel();
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    if (this.typeModal === 'add') {
      await this.addCp();
    } else if (this.typeModal === 'edit') {
      await this.editCp();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/ivr/script/list/list.component.ts